// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"748dfe55","563":"116a0d39","787":"957e0b6a"}[chunkId] + ".chunk.js";
};